module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/bg-b34bbc.png";